<template>
  <section class="preview">
    <form class="form" novalidate @submit.prevent="crear">
      <!-- Styled -->
      <mdb-input
        placeholder="Codigo pixel"
        class="mb-3 mt-0"
        v-model="name"
        required
        invalidFeedback="Coloca el codigo"
      >
        <span class="input-group-text md-addon" slot="prepend">Nombre</span>
      </mdb-input>

      

      <div class="form-group">
        <label class="typo__label">Ftp servers</label>
        <multiselect
          v-model="ftp_server_id"
          placeholder="Seleccione cuentas"
          label="name"
          track-by="id"
          :options="ftp_server_ids"
          :multiple="false"
          :taggable="true"
        ></multiselect>
      </div>

      

      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Crear</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>
  </section>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mdbInput, mdbBtn } from "mdbvue";
import { SemipolarSpinner } from "epic-spinners";
import store from "../../store";
export default {
  name: "modal-1",
  components: {
    mdbInput,
    mdbBtn,
    SemipolarSpinner,
    Multiselect
  },
  props: {
    onClick: Function
  },
  data: () => {
    return {
      isLoading: false,
      ftp_server_id: {},
      ftp_server_ids:[],
       name:""
    };
  },
  async mounted() {
    var respuesta = await this.getFtpServers();
  },
  methods: {
    async getFtpServers() {
      var ftp_server_ids = store.getters.getFtpServers;

      if (ftp_server_ids.length == 0) {
        store.dispatch("getFtpServers").then(() => {
          ftp_server_ids = store.getters.getFtpServers;
          this.ftp_server_ids = ftp_server_ids;
        });
      } else {
        this.ftp_server_ids = ftp_server_ids;
      }
    },
    crear(event) {
      event.target.classList.add("was-validated");
      var { name, ftp_server_id } = this;
      this.isLoading = true;
      if (name == "" || ftp_server_id == {}) {
        this.isLoading = false;
      } else {
        var website = {
          name,
          ftp_server_id
        };
        store.dispatch("newWebSite", website).then(() => {
          this.onClick();
          this.isLoading = false;
        });
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.prueba-circulo {
  background-image: url("");
  background-repeat: no-repeat;
  width: 200px;
  height: 200px;
  background: #cccccc;
  border-radius: 100%;
  position: relative;
}
.form {
  position: relative;
  bottom: 80px;
}
</style>